import { Select } from "@jsq/ds/core";
import type { ArenaOption } from "../hooks/useArenaOptions";

export type ArenaSelectProps = {
  arenas: ArenaOption[];
  arenasLoading: boolean;
  selectedArenaId: number | null;
  onChange: (value: string | number | string[] | number[]) => void;
};

export const ArenaSelect = ({
  arenas,
  arenasLoading,
  selectedArenaId,
  onChange,
}: ArenaSelectProps) => (
  <Select
    label="Client"
    placeholder="Select client"
    full
    disabled={arenasLoading}
    value={selectedArenaId != null ? String(selectedArenaId) : ""}
    onChange={onChange}
  >
    <Select.Section>
      {arenas.map((arena) => (
        <Select.Option key={arena.id} value={String(arena.id)}>
          {arena.name}
        </Select.Option>
      ))}
    </Select.Section>
  </Select>
);
